export const REDUCER_NAME = 'store'



// WEBPACK FOOTER //
// ./src/modules/store/state/const.js